import React from 'react';
import { array, number, object, oneOfType, string } from 'prop-types';
import clsx from 'clsx';

import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from './Autocomplete.module.css';

const Suggestion = ({
    classes,
    highlightedIndex,
    index,
    itemProps,
    label,
    selectedItem,
    selectedItemLabels
}) => {
    const isHighlighted = highlightedIndex === index;
    const isSelected = selectedItemLabels.includes(label);

    const nullifyMouseUp = event => {
        // This fix prevents the upperward propagation of the mouseup event, necessary because we use
        // ClickAwayListener in several areas of the application. ClickAwayListener also listens on mouseup,
        // and in certain circumstances will act before the listeners used by the TagSelect component. This
        // causes a defect where mouse selected items in TagSelect are ignored, and the whole list is refreshed.
        event.preventDefault();
    };

    return (
        <MenuItem
            {...itemProps}
            classes={{
                ...itemProps.classes,
                gutters: clsx(
                    defaultClasses.suggestionGutters,
                    classes.gutters
                ),
                root: clsx(
                    defaultClasses.suggestion,
                    classes.root
                ),
                selected: clsx(
                    defaultClasses.suggestionSelected,
                    classes.selected
                )
            }}
            key={label}
            selected={isHighlighted || isSelected}
            onMouseUp={nullifyMouseUp}
        >
            {label}
        </MenuItem>
    );
};

Suggestion.defaultProps = {
    classes: {}
};

Suggestion.propTypes = {
    highlightedIndex:   number,
    index:              number,
    itemProps:          object,
    label:              string.isRequired,
    selectedItem:       oneOfType([array, object, string, number]),
    selectedItemLabels: oneOfType([array, string])
};

export default Suggestion;
